module.exports = __webpack_public_path__ + "static/media/Dresden19.060af67c.jpg";